<app-company></app-company>
<app-order-lookup *ngIf='appData.selectedCompanyId'></app-order-lookup>
<app-shipping-rates *ngIf='!appData.currentOrder.hasTrackingNumber()'></app-shipping-rates>
